(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/zipcode-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/zipcode-input.js');
"use strict";

const TextInput = svs.ui.reactFormInputs.TextInput;
const ZIP = svs.ticket_partner.sharedComponents.input.constants.names.ZIP;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input.constants.TEXTS.ZIPCODE,
  LABEL = _svs$ticket_partner$s.LABEL,
  REQUIRED_ERROR = _svs$ticket_partner$s.REQUIRED_ERROR;
const validateZipCode = svs.ticket_partner.utils.validateZipCode;
const ZipCodeInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    disabled = _ref.disabled,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(TextInput, {
    disabled: disabled,
    errorMessageRequired: REQUIRED_ERROR,
    id: ZIP,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    name: name || ZIP,
    onChange: handleChange,
    validateFn: validateZipCode,
    value: state[ZIP] || ''
  });
};
svs.ticket_partner.sharedComponents.input.ZipCodeInput = ZipCodeInput;

 })(window);